import type { FC } from "react";
import ImageContainer from "../../../../general/ImageContainers";
import Icon from "../../../Icon";
import * as s from "./MaterialListItem.module.scss";

type fabricItem = {
	fabric: string;
	image: { src: string; alt?: string };
	description?: string | null;
	bullets?: readonly ({ readonly text: string | null } | null)[] | null;
};

type MaterialListItemProps = {
	fabrics: fabricItem[];
};

const MaterialListItem: FC<MaterialListItemProps> = ({ fabrics }) => {
	return (
		<>
			{fabrics.map((fabric, index) => (
				<li key={fabric.fabric} className={s.container}>
					<>
						<div key={index} className={s.imgWrapper}>
							<ImageContainer
								ratio="portrait"
								imgSrc={fabric.image.src}
								alt={fabric.image.alt ?? fabric.fabric}
								className={s.image}
							/>
						</div>
						<div className={s.contentWrapper}>
							<h4>{fabric.fabric}</h4>
							{fabric.description && <p>{fabric.description}</p>}
							{fabric.bullets && (
								<ul>
									{fabric.bullets.map(
										(bullet, index) =>
											bullet && (
												<li key={`${bullet.text}-${index}`}>
													<Icon icon="dot-single" />
													<p>{bullet.text}</p>
												</li>
											),
									)}
								</ul>
							)}
						</div>
					</>
				</li>
			))}
		</>
	);
};
export default MaterialListItem;
